import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconAddToReport = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M7.26772 4.75H6.28888C5.3394 4.75 4.75 5.39965 4.75 6.00324V18.9968C4.75 19.6003 5.3394 20.25 6.28888 20.25H13.75C14.1642 20.25 14.5 20.5858 14.5 21C14.5 21.4142 14.1642 21.75 13.75 21.75H6.28888C4.70503 21.75 3.25 20.6104 3.25 18.9968V6.00324C3.25 4.38965 4.70503 3.25 6.28888 3.25H7.26772C7.38903 2.40193 8.11838 1.75 9 1.75H15C15.8816 1.75 16.611 2.40193 16.7323 3.25H17.7111C19.295 3.25 20.75 4.38965 20.75 6.00324V14.75C20.75 15.1642 20.4142 15.5 20 15.5C19.5858 15.5 19.25 15.1642 19.25 14.75V6.00324C19.25 5.39965 18.6606 4.75 17.7111 4.75H16.7323C16.611 5.59807 15.8816 6.25 15 6.25H9C8.11838 6.25 7.38903 5.59807 7.26772 4.75ZM8.75 4.5C8.75 4.63807 8.86193 4.75 9 4.75H15C15.1381 4.75 15.25 4.63807 15.25 4.5V3.5C15.25 3.36193 15.1381 3.25 15 3.25H9C8.86193 3.25 8.75 3.36193 8.75 3.5V4.5Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M17 13.75C17.4142 13.75 17.75 14.0858 17.75 14.5V17.25H20.5C20.9142 17.25 21.25 17.5858 21.25 18C21.25 18.4142 20.9142 18.75 20.5 18.75H17.75V21.5C17.75 21.9142 17.4142 22.25 17 22.25C16.5858 22.25 16.25 21.9142 16.25 21.5V18.75H13.5C13.0858 18.75 12.75 18.4142 12.75 18C12.75 17.5858 13.0858 17.25 13.5 17.25H16.25V14.5C16.25 14.0858 16.5858 13.75 17 13.75Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.25 10.625C7.25 10.2108 7.58579 9.875 8 9.875H16C16.4142 9.875 16.75 10.2108 16.75 10.625C16.75 11.0392 16.4142 11.375 16 11.375H8C7.58579 11.375 7.25 11.0392 7.25 10.625Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M8 13.625C7.58579 13.625 7.25 13.9608 7.25 14.375C7.25 14.7892 7.58579 15.125 8 15.125H13.75C14.1642 15.125 14.5 14.7892 14.5 14.375C14.5 13.9608 14.1642 13.625 13.75 13.625H8Z",
			fill: "currentColor"
		})
	]
});
export { SvgIconAddToReport as ReactComponent };
